import brand from '../../../branding';

const base = {
  primaryColor: '#3ea0cd',
  secondaryColor: '#999',
  tertiaryColor: '#bd1414',
  primaryBackgroundColor: '#f9fbfc',
  secondaryBackgroundColor: '#fff',
  tertiaryBackgroundColor: '#fff',
  errorPrimary: '#8e4545',
  errorBackground: '#fcdcdc',

  primaryFontColor: '#56565b',
  secondaryFontColor: '#9a9a9d',
  tertiaryFontColor: '#bbbbbd',
  quaternaryFontColor: '#eeeeee',
  baseIconColor: '#56565b',

  slaPrimary: {
    urgentlyUpcoming: '#ea6b33',
    upcomingToday: '#d69822',
    upcoming: '#1f1f90',
    missedDeadline: '#a81c1c',
    doneOnTime: '#31af6b',
  },
  slaSecondary: {
    urgentlyUpcoming: '#f9d2c1',
    upcomingToday: '#fce9c6',
    upcoming: '#bbbbdd',
    missedDeadline: '#e5baba',
    doneOnTime: '#c1e7d2',
  },
  slaBackground: {
    urgentlyUpcoming: '#fdf0ea',
    upcomingToday: '#fbf4e8',
    upcoming: '#e8e8f4',
    missedDeadline: '#f6e8e8',
    doneOnTime: '#eaf7f0',
  },
  slaShadow: {
    urgentlyUpcoming: '#fcdcdc',
    upcomingToday: '#fdf1d9',
    upcoming: '#ddddde',
    missedDeadline: '#e9d2d2',
    doneOnTime: '#d6efe1',
  },
};

// Merge the active brand's colour overrides over the base palette (shallow - brands
// override only flat top-level colour keys, leaving the SLA groups intact).
export default { ...base, ...(brand.colors || {}) };
